export const gateBooleanToBoolean = (gateBoolean: string) => gateBoolean === "Y";

export const booleanToGateBoolean = (boolean: boolean) => boolean === true ? "Y" : "N";


export const gateNonstandardDateToDate = (str: string): Date | null => {
    const [date = "", time = ""] = str.split(" ");

    const [day, month, year] = date.split(".");
    const [hour, minute, second] = time.split(":");

    const values = [day, month, year, hour, minute, second].map((v) => parseInt(v, 10));

    const nans = values.filter(Number.isNaN);

    if (nans.length > 0) {
        return null;
    }

    return new Date(
        values[2],
        values[1] - 1,
        values[0],
        values[3],
        values[4],
        values[5],
    );
};


const GATE_EMPTY_PROP = "(null)";

/**
 * Adds flags for empty values in object, so backend knows that field is empty.
 * @param obj 
 */
export const emptyPropertiesToGateEmptyProperties = (obj: { [key: string]: any }): { [key: string]: any } => {
    return Object.keys(obj).reduce<{ [key: string]: any }>((acc, key) => {
        let prop = obj[key];

        if (typeof prop === "object") {
            acc[key] = emptyPropertiesToGateEmptyProperties(prop)
        } else if (prop === null) {
            acc[key] = GATE_EMPTY_PROP;
        } else if (prop === "") {
            acc[key] = GATE_EMPTY_PROP;
        } else {
            acc[key] = prop;
        }

        return acc;
    }, {})
};